import React from 'react';

import { Box } from '@clutter/clean';

export const Section: React.FC<React.ComponentPropsWithoutRef<typeof Box>> = ({
  children,
  padding,
  ...props
}) => (
  <Box padding="0 24px" {...props}>
    <Box maxWidth="1230px" margin="0 auto" padding={padding}>
      {children}
    </Box>
  </Box>
);
